// extracted by mini-css-extract-plugin
export default {"drawerTitle":"drawerTitle--oM8LT","firstScreenRightCon":"firstScreenRightCon--Bd0NE","markerAnimationScale":"markerAnimationScale--a7drS"};